
import { Component, Vue, Prop } from 'vue-property-decorator';
import CameraPageShootCardAutoPatternDriversLicenseFront from '@/components/CameraPageShootCardAutoPatternDriversLicenseFront.vue';
import CameraPageShootCardAutoPatternDriversLicenseDiagonal1 from '@/components/CameraPageShootCardAutoPatternDriversLicenseDiagonal1.vue';
import CameraPageShootCardAutoPatternDriversLicenseDiagonal2 from '@/components/CameraPageShootCardAutoPatternDriversLicenseDiagonal2.vue';
import CameraPageShootCardAutoPatternDriversLicenseBack from '@/components/CameraPageShootCardAutoPatternDriversLicenseBack.vue';
import CameraPageShootCardAutoPatternMyNumberCardFront from '@/components/CameraPageShootCardAutoPatternMyNumberCardFront.vue';
import CameraPageShootCardAutoPatternMyNumberCardDiagonal1 from '@/components/CameraPageShootCardAutoPatternMyNumberCardDiagonal1.vue';
import CameraPageShootCardAutoPatternMyNumberCardDiagonal2 from '@/components/CameraPageShootCardAutoPatternMyNumberCardDiagonal2.vue';
import { is } from '@/util/idDoc';

@Component({
  components: {
    CameraPageShootCardAutoPatternDriversLicenseFront,
    CameraPageShootCardAutoPatternDriversLicenseDiagonal1,
    CameraPageShootCardAutoPatternDriversLicenseDiagonal2,
    CameraPageShootCardAutoPatternDriversLicenseBack,
    CameraPageShootCardAutoPatternMyNumberCardFront,
    CameraPageShootCardAutoPatternMyNumberCardDiagonal1,
    CameraPageShootCardAutoPatternMyNumberCardDiagonal2
  }
})
export default class Parts extends Vue {
  @Prop({ type: String, required: true })
  public status!: 'none' | 'capture' | 'success';

  @Prop({ type: Boolean, required: true })
  public isTimeout!: boolean;

  private get isIdDocFront(): boolean {
    return this.$store.state.camera.shootType === 'identity-document-front';
  }

  private get isIdDocDiagonal(): boolean {
    return this.$store.state.camera.shootType === 'identity-document-diagonal';
  }

  private get isIdDocBack(): boolean {
    return this.$store.state.camera.shootType === 'identity-document-back';
  }

  private get isIdDocDriversLicense(): boolean {
    if (is(this.$store.state.camera.idDocType, 'drivers-license')) return true;
    if (is(this.$store.state.camera.idDocType, 'driving-history-certificate')) return true;

    return false;
  }

  private get isIdDocMyNumberCard(): boolean {
    if (is(this.$store.state.camera.idDocType, 'my-number-card')) return true;

    return false;
  }
}
